import {
    getJobTitlesList,
    addSingleJobTitle,
    deleteSingleJobTitle,
    GetJobTitlesListResponse,
    AddJobTitleRequest,
    getSingleJobTitle,
    updateSingleJobTitle
} from '@/modules/job-titles/api'
import { computed, ref } from 'vue'

const jobTitles = ref<GetJobTitlesListResponse>([])

const getJobTitles = () => getJobTitlesList().then(jobTitlesList => {
    jobTitles.value = jobTitlesList.map(jobTitle => {
        return {
            id: jobTitle.id.toString(),
            title: jobTitle.title
        }
    })
})

const addJobTitle = (payload: AddJobTitleRequest) => addSingleJobTitle(payload).then(getJobTitles)

const updateJobTitle = (id: string, payload: AddJobTitleRequest) => updateSingleJobTitle(id, payload).then(getJobTitles)

const deleteJobTitle = (id: string) => deleteSingleJobTitle(id).then(getJobTitles)

export function useJobTitleModule () {
    return {
        getJobTitles,
        jobTitles: computed(() => jobTitles.value),
        deleteJobTitle,
        addJobTitle,
        getSingleJobTitle,
        updateJobTitle
    }
}
